import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { validator } from "../../../libs/validator";
import { Alert, Form, Input } from "antd";
import { Link } from "react-router-dom";
import loginErrore from "../../../assets/img/login-errore.svg";
import { login } from "../../../store/actions/auth/index";
import { login_sso } from "../../../store/actions/sso";

const FormItem = Form.Item;
const Password = Input.Password;
const DefaultLogin = ({
  buttonLink,
  isForgotLink,
  isClicked,
  putIsClicked,
  putToLogin,
  messageInfo,
  isSso,
  toLogin
}) => {
  const useMergeState = initialState => {
    const [state, setState] = useState(initialState);
    const setMergedState = newState =>
      setState(prevState => Object.assign(
        {}, prevState, newState
      ));
    return [state, setMergedState];
  };

  const [emailValue, setEmailValue] = useState("");
  const [email, setEmail] = useMergeState({ help: "", status: "" });
  const [passwordValue, setPasswordValue] = useState("");
  const [password, setPassword] = useMergeState({ help: "", status: "" });
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const auth = useSelector(state => state.auth);
  const sso = useSelector(state => state.sso);
  const error = !isSso
    ? auth.status.error
    : sso.status
      ? sso.status.error
      : null;
  const errorInfo = !isSso
    ? auth.status.errorInfo
    : sso.status
      ? sso.status.errorInfo
      : null;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isClicked) {
      handleSubmit();
      putIsClicked(false);
      setIsFirstLoad(false);
      setPassword({ status: "", help: "" });
    }

  }, [isClicked]);

  useEffect(() => {
    if (
      error &&
      (errorInfo.code === "401" || errorInfo.code === "403") &&
      !isFirstLoad
    ) {
      setEmail({ status: "error", help: "" });
      setPassword({ status: "error", help: "" });
    }
  }, [error, errorInfo]);

  const handleSubmit = e => {
    if (!validator.isEmail(emailValue)) {
      setEmail({ status: "error", help: "" });
    } else {
      setEmail({ status: "", help: "" });
    }
    if (passwordValue === "") {
      setPassword({ status: "error", help: "" });
    } else {
      setPassword({ status: "", help: "" });
    }
    if (
      (email.status !== "error" && password.status !== "error") ||
      !isFirstLoad
    ) {
      if (!isSso) {
        dispatch(login(
          "DIGITALBOXWEB", emailValue, passwordValue
        ));
      } else {
        dispatch(login_sso(
          "DIGITALBOXWEB", emailValue, passwordValue
        ));
      }
    }
    if (error && errorInfo.code === "500") {
      putToLogin(false);
    }
  };

  return error && errorInfo.code === "500" && !isFirstLoad && !toLogin ? (
    <div>
      <div style={{ marginTop: "90px", marginBottom: "50px" }}>
        <img width="159px" height="158px" src={loginErrore} alt="Login error" />
      </div>
      <div style={{ fontSize: "16px", marginBottom: "30px" }}>
        Oops, qualcosa è andato storto, riprova
      </div>
      <div style={{ fontSize: "16px", marginBottom: "120px" }}>
        <Link
          style={{ color: "#0090d1" }}
          to={"/"}
          onClick={el => {
            putToLogin(true);
          }}
        >
          Torna alla login
        </Link>
      </div>
    </div>
  ) : (
    <div>
      <div className="textTsId">{messageInfo}</div>
      <div style={{ marginTop: "16px" }}>{buttonLink}</div>
      <div className="orDivContainer">
        <div style={{ flex: "1 1 auto" }}>
          <hr className="hrHalfDivider" />
        </div>
        <div style={{ margin: "0 16px", color: "#5a6872" }}> oppure</div>
        <div style={{ flex: "1 1 auto" }}>
          <hr className="hrHalfDivider" />
        </div>
      </div>

      {auth &&
      auth.status.message &&
      auth.status.message.indexOf("Password cambiata con successo") > -1 ? (
          <Alert
            style={{ wordBreak: "break-word" }}
            message="La password è stata modificata con successo. Effettua nuovamente la login"
            description={""}
            type="success"
            showIcon
          />
        ) : null}

      <div>
        <label style={{ marginBottom: 18 }}>E-mail</label>
        <FormItem validateStatus={email.status} help={email.help}>
          <Input
            value={emailValue}
            onChange={e => {
              // if (!validator.isEmail(e.target.value)){
              //     setEmail({status: "error", help: ""});
              //   } else {
              setEmail({ status: "", help: "" });
              // }
              setEmailValue(e.target.value);
            }}
            placeholder="La tua e-mail"
          />
        </FormItem>
      </div>
      <div style={{ marginTop: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ marginBottom: 18 }}>
            <label>Password</label>
          </div>
          {isForgotLink ? (
            <Link to="password-dimenticata">
              <div style={{ marginLeft: "80px" }}>Password dimenticata?</div>
            </Link>
          ) : (
            <div></div>
          )}
        </div>
        <FormItem validateStatus={password.status} help={password.help}>
          <Password
            value={passwordValue}
            onChange={e => {
              //   if (passwordValue === ""){
              //   setPassword({status: "error", help: ""});
              // } else {
              setPassword({ status: "", help: "" });
              // }
              setPasswordValue(e.target.value);
            }}
            placeholder="La tua password"
          />
        </FormItem>
      </div>
      {error &&
      (errorInfo.code === "401" || errorInfo.code === "403") &&
      !isFirstLoad ? (
          <div className="errorBottom">
            {errorInfo.message}
            {"E-mail o password errata. Riprova."}
          </div>
        ) : email.status === "error" || password.status === "error" ? (
          <div className="errorBottom">
            {"E-mail o password errata. Riprova."}
          </div>
        ) : null}
    </div>
  );
};

export default DefaultLogin;
